<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{previousMonth | moneyNoDecimal}}</h2>
                <span>Total Mês Passado (Líquido)</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4"
                style="background: rgba(var(--vs-danger),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{previousMonthRefunds | money}}</h2>
                <span>Devoluções Mês Passado</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-success mb-4"
                style="background: rgba(var(--vs-success),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{currentMonth | moneyNoDecimal}}</h2>
                <span>Total Mês Atual (Líquido)</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4">
        <vx-card class="overflow-hidden mb-4">
          <div slot="no-body">
            <div class="p-6 flex justify-between flex-row-reverse items-center">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-danger mb-4"
                style="background: rgba(var(--vs-danger),0.15);"
              >
                <i class="fas fa-money-bill-alt fa-2x"></i>
              </span>
              <div class="truncate">
                <h2 class="mb-1 font-bold">{{currentMonthRefunds | money}}</h2>
                <span>Devoluções Mês Atual</span>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="mt-5">
      <vs-table ref="table" noDataText="Nenhum item encontrado" :data="admins" :stripe="true">
        <template slot="thead">
          <vs-th>NOME</vs-th>
          <vs-th>MÊS ANTERIOR</vs-th>
          <vs-th>%</vs-th>
          <vs-th>MÊS ATUAL</vs-th>
          <vs-th>%</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" v-for="(tr, idx) in data" :key="idx">
            <vs-td>{{data[idx].name}}</vs-td>
            <vs-td>{{data[idx].previousMonthComission | moneyNoDecimal}}</vs-td>
            <vs-td>{{data[idx].previousMonthComissionPercentage | decimal}}</vs-td>
            <vs-td>{{data[idx].currentMonthComission | moneyNoDecimal}}</vs-td>
            <vs-td>{{data[idx].currentMonthComissionPercentage | decimal}}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentMonth: 0,
      currentMonthRefunds: 0,
      previousMonth: 0,
      previousMonthRefunds: 0,
      admins: []
    };
  },

  mounted() {
    this.load();
  },

  methods: {
    load() {
      this.$vs.loading();

      this.$api
        .get('/api/v1/backend/comission')
        .then(response => {
          this.$vs.loading.close();
          this.admins = response.data.admins;
          this.currentMonth = response.data.currentMonth;
          this.currentMonthRefunds = response.data.currentMonthRefunds;
          this.previousMonth = response.data.previousMonth;
          this.previousMonthRefunds = response.data.previousMonthRefunds;
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    }
  }
};
</script>
